<template>
  <img
    src="~/assets/icon/icon-user-dark.svg"
    alt=""
  />
</template>
